import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../assets/fstyr-theme.scss";
import "dkfds/dist/css/dkfds.css";
import { Fstyr } from "../components/FstyrComponents/Fstyr";
import * as DKFDS from "dkfds";

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor(props) {
    super(props);

    // Checks
    let selectedTab = this.checkForActiveTab();
    this.state = {
      selectedTab: selectedTab,
      isPolice: global.config.isPolice,
    };
  }

  signOut() {
    window.location.replace("https://" + window.location.host + "/api/Authentication/authenticateNemloginLogout");
  }

  checkForActiveTab() {
    let currentLocation = window.location.pathname;
    if (currentLocation.includes("drivercard")) return "A";
    if (currentLocation.includes("workshopcard")) return "B";
    if (currentLocation.includes("businesscard")) return "C";
    if (currentLocation.includes("controlcard")) return "D";
    if (currentLocation.includes("other")) return "E";
    return "";
  }

  refreshPageNav(tab) {
    if (tab === this.state.selectedTab) {
      return true;
    }
  }

  reload() {
    window.location.reload();
  }

  setSelectedNavAndMenu(tab) {
    if (tab.length !== 1) {
      this.setState({
        selectedTab: tab,
      });
    }

    if (tab === "A") {
      this.workshopTabBox.ariaHidden = "true";
      this.workshopTabButton.ariaExpanded = "false";
      this.businessTabBox.ariaHidden = "true";
      this.businessTabButton.ariaExpanded = "false";
      this.controlTabBox.ariaHidden = "true";
      this.controlTabButton.ariaExpanded = "false";

      this.otherTabBox.ariaHidden = "true";
      this.otherTabButton.ariaExpanded = "false";
    } else if (tab === "B") {
      this.driverTabBox.ariaHidden = "true";
      this.driverTabButton.ariaExpanded = "false";
      this.businessTabBox.ariaHidden = "true";
      this.businessTabButton.ariaExpanded = "false";
      this.controlTabBox.ariaHidden = "true";
      this.controlTabButton.ariaExpanded = "false";

      this.otherTabBox.ariaHidden = "true";
      this.otherTabButton.ariaExpanded = "false";
    } else if (tab === "C") {
      this.driverTabBox.ariaHidden = "true";
      this.driverTabButton.ariaExpanded = "false";
      this.workshopTabBox.ariaHidden = "true";
      this.workshopTabButton.ariaExpanded = "false";
      this.controlTabBox.ariaHidden = "true";
      this.controlTabButton.ariaExpanded = "false";

      this.otherTabBox.ariaHidden = "true";
      this.otherTabButton.ariaExpanded = "false";
    } else if (tab === "D") {
      this.driverTabBox.ariaHidden = "true";
      this.driverTabButton.ariaExpanded = "false";
      this.businessTabBox.ariaHidden = "true";
      this.businessTabButton.ariaExpanded = "false";
      this.workshopTabBox.ariaHidden = "true";
      this.workshopTabButton.ariaExpanded = "false";

      this.otherTabBox.ariaHidden = "true";
      this.otherTabButton.ariaExpanded = "false";
    } else if (tab === "E") {
      this.driverTabBox.ariaHidden = "true";
      this.driverTabButton.ariaExpanded = "false";
      this.businessTabBox.ariaHidden = "true";
      this.businessTabButton.ariaExpanded = "false";
      this.workshopTabBox.ariaHidden = "true";
      this.workshopTabButton.ariaExpanded = "false";
      this.controlTabBox.ariaHidden = "true";
      this.controlTabButton.ariaExpanded = "false";
    }
  }

  componentDidMount() {
    DKFDS.init();
  }

  getEnvironmentName() {
    if (window.location.href.includes("test")) {
      return "TEST";
    } else if (window.location.href.includes("local")) {
      return "UDVIKLING";
    } else if (window.location.href.includes("preprod")) {
      return "PRE PRODUKTION";
    } else {
      return null;
    }
  }

  render() {
    return (
      <header className="header">
        <div className="row justify-content-center background-color">
          <div className="col-sm-12 col-md-10 col-lg-8 col-xl-7 hide-shit ">
            {this.getEnvironmentName() != null && (
              <div style={{ display: "flex", pointerEvents: "none", justifyContent: "center", alignItems: "center", position: "fixed", top: 0, left: "35%", width: "30%", height: 50, backgroundColor: "rgba(255, 0, 0, 0.4)", borderBottomLeftRadius: 40, borderBottomRightRadius: 40, zIndex: 2000 }}>
                <h2>{this.getEnvironmentName()}</h2>
              </div>
            )}

            <div className="portal-header portal-header-compact">
              <div className="container portal-header-inner space-around">
                <a href="/" aria-label="Portalnavn" className="logo">
                  <span className="d-none d-print-block">Portalnavn</span>
                </a>
                <div className="portal-info">
                  <p className="user">{this.state.isPolice ? null : this.props.userName}</p>
                </div>
                {this.props.isPolice && this.props.isAuthenticated && (
                  <div style={{ marginLeft: 20 }}>
                    <Fstyr.Button type="secondary" label="Log af" onClick={() => this.signOut()} />
                  </div>
                )}
              </div>
            </div>
            <div className="solution-header">
              <div className="container solution-header-inner">
                <div className="solution-heading">
                  <Link to="/" className="alert-leave2">
                    {"Tachonet" + (this.props.isPolice ? " (Politi)" : "")}
                  </Link>
                </div>

                <div className="solution-info" style={{ marginTop: "-35px" }}>
                  <p className="h5 authority-name">Færdselsstyrelsen</p>
                  <p>
                    Færdselsstyrelsen: <a href="mailto: applikationssupport@fstyr.dk">applikationssupport@fstyr.dk</a> (primær)
                  </p>
                  <p>Statens IT: 7231 0001 (sekundær)</p>
                </div>
              </div>
            </div>

            <div className="navbar navbar-primary">
              <div className="navbar-inner container">
                <ul className="nav-primary">
                  <li className={this.state.selectedTab[0] === "A" ? "current" : ""}>
                    <div className="overflow-menu">
                      <button className="button-overflow-menu js-dropdown js-dropdown--responsive-collapse" data-js-target="headeroverflow1" aria-haspopup="true" aria-expanded="false" ref={(driverTabBtn) => (this.driverTabButton = driverTabBtn)} onFocus={() => this.setSelectedNavAndMenu("A")}>
                        <span>Førerkort</span>
                      </button>
                      <div className="overflow-menu-inner" id="headeroverflow1" aria-hidden="true" ref={(driverTabBox) => (this.driverTabBox = driverTabBox)}>
                        <ul className="overflow-list">
                          {!this.props.isPolice && (
                            <li className={this.state.selectedTab === "A1" ? "active" : ""}>
                              <Link onClick={() => this.setSelectedNavAndMenu("A1")} to={this.refreshPageNav("A1") ? this.reload() : "/drivercard/create"}>
                                Opret
                              </Link>
                            </li>
                          )}

                          <li className={this.state.selectedTab === "A2" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("A2")} to={this.refreshPageNav("A2") ? this.reload() : "/drivercard/searchcard/0"}>
                              Søg Kortnr
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "A3" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("A3")} to={this.refreshPageNav("A3") ? this.reload() : "/drivercard/searchcpr"}>
                              Søg CPR
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "A4" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("A4")} to={this.refreshPageNav("A4") ? this.reload() : "/drivercard/searcheuperson"}>
                              Søg EU person
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li className={this.state.selectedTab[0] === "B" ? "current" : ""}>
                    <div className="overflow-menu">
                      <button className="button-overflow-menu js-dropdown js-dropdown--responsive-collapse" data-js-target="headeroverflow2" aria-haspopup="true" aria-expanded="false" ref={(workshopTabButton) => (this.workshopTabButton = workshopTabButton)} onFocus={() => this.setSelectedNavAndMenu("B")}>
                        <span>Værkstedskort</span>
                      </button>
                      <div className="overflow-menu-inner" id="headeroverflow2" aria-hidden="true" ref={(workshopTabBox) => (this.workshopTabBox = workshopTabBox)}>
                        <ul className="overflow-list">
                          {!this.props.isPolice && (
                            <li className={this.state.selectedTab === "B1" ? "active" : ""}>
                              <Link onClick={() => this.setSelectedNavAndMenu("B1")} to={this.refreshPageNav("B1") ? this.reload() : "/workshopcard/create"}>
                                Opret
                              </Link>
                            </li>
                          )}

                          <li className={this.state.selectedTab === "B2" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("B2")} to={this.refreshPageNav("B2") ? this.reload() : "/workshopcard/searchworkshopcard/0"}>
                              Søg Kortnr
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "B3" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("B3")} to={this.refreshPageNav("B3") ? this.reload() : "/workshopcard/searchworkshopcpr"}>
                              Søg CPR
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "B4" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("B4")} to={this.refreshPageNav("B4") ? this.reload() : "/workshopcard/searchworkshopcvr"}>
                              Søg CVR
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li className={this.state.selectedTab[0] === "C" ? "current" : ""}>
                    <div className="overflow-menu">
                      <button className="button-overflow-menu js-dropdown js-dropdown--responsive-collapse" data-js-target="headeroverflow3" aria-haspopup="true" aria-expanded="false" ref={(businessTabButton) => (this.businessTabButton = businessTabButton)} onFocus={() => this.setSelectedNavAndMenu("C")}>
                        <span>Virksomhedskort</span>
                      </button>
                      <div className="overflow-menu-inner" id="headeroverflow3" aria-hidden="true" ref={(businessTabBox) => (this.businessTabBox = businessTabBox)}>
                        <ul className="overflow-list">
                          {!this.props.isPolice && (
                            <li className={this.state.selectedTab === "C1" ? "active" : ""}>
                              <Link onClick={() => this.setSelectedNavAndMenu("C1")} to={this.refreshPageNav("C1") ? this.reload() : "/businesscard/create"}>
                                Opret
                              </Link>
                            </li>
                          )}

                          <li className={this.state.selectedTab === "C2" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("C2")} to={this.refreshPageNav("C2") ? this.reload() : "/businesscard/searchbusinesscard/0"}>
                              Søg Kortnr
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "C3" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("C3")} to={this.refreshPageNav("C3") ? this.reload() : "/businesscard/searchbusinessCVR"}>
                              Søg CVR/CPR
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li className={this.state.selectedTab[0] === "D" ? "current" : ""}>
                    <div className="overflow-menu">
                      <button className="button-overflow-menu js-dropdown js-dropdown--responsive-collapse" data-js-target="headeroverflow4" aria-haspopup="true" aria-expanded="false" ref={(controlTabButton) => (this.controlTabButton = controlTabButton)} onFocus={() => this.setSelectedNavAndMenu("D")}>
                        <span>Kontrolkort</span>
                      </button>
                      <div className="overflow-menu-inner" id="headeroverflow4" aria-hidden="true" ref={(controlTabBox) => (this.controlTabBox = controlTabBox)}>
                        <ul className="overflow-list">
                          {global.config.isPolice && (
                            <li className={this.state.selectedTab === "D1" ? "active" : ""}>
                              <Link onClick={() => this.setSelectedNavAndMenu("D1")} to="/controlcard/create">
                                Opret
                              </Link>
                            </li>
                          )}
                          <li className={this.state.selectedTab === "D2" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("D2")} to={this.refreshPageNav("D2") ? this.reload() : "/controlcard/searchControlCard/0"}>
                              Søg Kortnr (gammelt)
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "D5" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("D5")} to={this.refreshPageNav("D5") ? this.reload() : "/controlcard/searchControlG2V2/0"}>
                              Søg Kortnr (G2V2)
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "D3" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("D3")} to={this.refreshPageNav("D3") ? this.reload() : "/controlcard/searchControlWRX"}>
                              Søg ID-nummer
                            </Link>
                          </li>
                          <li className={this.state.selectedTab === "D4" ? "active" : ""}>
                            <Link onClick={() => this.setSelectedNavAndMenu("D4")} to={this.refreshPageNav("D4") ? this.reload() : "/controlcard/searchControlAuthority"}>
                              Søg Myndighed
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  {!global.config.isPolice && (
                    <li className={this.state.selectedTab[0] === "E" ? "current" : ""}>
                      <div className="overflow-menu">
                        <button className="button-overflow-menu js-dropdown js-dropdown--responsive-collapse" data-js-target="headeroverflow5" aria-haspopup="true" aria-expanded="false" ref={(otherTabButton) => (this.otherTabButton = otherTabButton)} onFocus={() => this.setSelectedNavAndMenu("E")}>
                          <span>Andet</span>
                        </button>
                        <div className="overflow-menu-inner" id="headeroverflow5" aria-hidden="true" ref={(otherTabBox) => (this.otherTabBox = otherTabBox)}>
                          <ul className="overflow-list">
                            <li className={this.state.selectedTab === "E1" ? "active" : ""}>
                              <Link onClick={() => this.setSelectedNavAndMenu("E1")} to={this.refreshPageNav("E1") ? this.reload() : "/other/bestillingsoversigt"}>
                                Se Bestillingsoversigt
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
